import React from "react";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import langIcon from "../../assets/images/language_icon.svg";
import { Link } from "react-router-dom";
import i18n from "../../i18n";
import { store } from "../../redux/storeConfig/store";
import {
  setDirectionType,
  setLanguageType,
} from "../../redux/actions/api/apiAction";
import { NavbarBrand } from "reactstrap";
import { HashLink as HLink } from "react-router-hash-link";

const NewNavBar = (props) => {
  const staff_login_url = process.env.REACT_APP_GYM_PANEL_URL;
  console.log(staff_login_url);
  const changeLanguage = async (lng) => {
    i18n.changeLanguage(lng);
    if (lng === "en") {
      await store.dispatch(setLanguageType("en"));
      await store.dispatch(setDirectionType("ltr"));
    } else {
      await store.dispatch(setLanguageType("ar"));
      await store.dispatch(setDirectionType("rtl"));
    }
  };

  console.log(i18n.language);

  const rightBusinessLinks = ["pricing", "contact-us"];

  return (
    <div
      className="d-flex p-2  justify-content-center"
      style={
        props.fromBusiness
          ? { width: "100vw", height: "9.87%", background: "#ffffff" }
          : { width: "100vw", height: "9.87%" }
      }
    >
      {/* Header Container */}
      <div className="d-flex p-2 justify-content-between header-general-container align-items-center ">
        <NavbarBrand className="c-pointer">
          <Link to="/">
            <img src={require("../../assets/images/connecttofitlogo.svg")} />
          </Link>
        </NavbarBrand>
        {/* Right Side Header */}
        <div
          style={{
            width: props.forLanding ? "200px" : "",
            color: "#4D4467",
            fontStyle: "normal",
            fontWeight: "600",
            lineHeight: "24px",
          }}
          className="d-inline-flex justify-content-between align-items-center"
        >
          {props.forLanding && (
            <>
              <span
                style={{
                  fontFamily: "Montserrat",
                }}
              >
                <HLink to="enterprise#contact-us" style={{ color: "inherit" }}>
                  {i18n.t("contact-us")}
                </HLink>
              </span>
              <span> | </span>
              <div
                className="d-inline-flex justify-content-around"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  changeLanguage(i18n.language === "en" ? "ar" : "en")
                }
              >
                <img
                  style={{ width: "24px", marginRight: "11.45%" }}
                  src={langIcon}
                  alt="lang"
                />
                <span>{i18n.t("language")}</span>
              </div>
            </>
          )}
        </div>
        {props.fromBusiness && (
          <>
            <div className="business-links-container d-inline-flex justify-content-between align-items-center">
              {rightBusinessLinks.map((link) => {
                return (
                  <a
                    href={`#${link.toLowerCase().replace(/\s/g, "")}`}
                    className="business-nav-links"
                  >
                    {i18n.t(link)}
                  </a>
                );
              })}
              <div
                className="d-inline-flex business-nav-links   justify-content-around"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  changeLanguage(i18n.language === "en" ? "ar" : "en")
                }
              >
                <span>{i18n.t("language")}</span>
              </div>
              <a href={staff_login_url}>
                <button className="business-staff-login-navBtn">
                  {i18n.t("staff_login")}
                </button>
              </a>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps)(withNamespaces()(NewNavBar));
